// extracted by mini-css-extract-plugin
export default {"ctn":"visualization_ctn__haP9Z","imgBox":"visualization_imgBox__QJuvF","textBox":"visualization_textBox__IlF6V"};